import PlatformApi from './_platformApi';

class DepartmentApi extends PlatformApi {
  controllerName = 'Departments';

  /**
   * Đồng bộ cơ cấu tổ chức
   */
  syncMulti(organizations) {
    const request = {
      url: this.getAPIUrl() + '/sync-multi',
      data: organizations,
    };

    return this.postAsync(request);
  }

  getSyncData() {
    const request = {
      url: this.getAPIUrl() + '/get-sync-data',
    };

    return this.getAsync(request);
  }

  /**
   * Kiểm tra xem người dùng hiện tại có phải là admin của phòng ban hay không
   * @returns 
   * ndhieu6 15/06/2025
   */
  checkAdminDepartment() {
    const request = {
      url: this.getAPIUrl() + '/check-admin-department',
    };

    return this.getAsync(request);
  }

}

export default new DepartmentApi();
